import axios from "axios"
import { config } from './apiUrl';

export  const GetWarrantAnnouncements = () =>{
  return axios.get(`${config.warrantAnnouncement}`)}